import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Authorize from '../../components/AuthComponent/Authorize';
import SaveButton from '../../components/Buttons/SaveButton';
import ButtonBar from '../../components/Fields/ButtonBar';
import Form from '../../components/Fields/Form';
import SelectListField from '../../components/Fields/SelectListField';
import { FieldConfig, FormConfig } from '../../components/Fields/Types';
import useSelectListOptions from '../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import { HorizontalTabs } from '../../components/Tabs/HorizontalTabs';
import { ApplicationFunctions } from '../../contexts/authContext';
import EmployeeMaintenance_tab_Brands from './Tabs/EmployeeMaintenance_tab_Brands';
import EmployeeMaintenance_tab_ItemRevisions from './Tabs/EmployeeMaintenance_tab_ItemRevisions';
import EmployeeMaintenance_tab_Projects from './Tabs/EmployeeMaintenance_tab_Projects';
import EmployeeMaintenance_tab_WorkflowTasks from './Tabs/EmployeeMaintenance_tab_WorkflowTasks';
import EmployeeMaintenance_tab_ProductCategories from './Tabs/EmployeeMaintenance_tab_ProductCategories';
import EmployeeMaintenance_tab_BusinessPartners from './Tabs/EmployeeMaintenance_tab_BusinessPartners';

interface EmployeeMaintenanceModel {
    fromEmployeeId: number
    toEmployeeId: number
}

const EmployeeMaintenanceView: React.FC = () => {
    const [formData, setFormData] = useState<EmployeeMaintenanceModel>({} as EmployeeMaintenanceModel);

    const employees = useSelectListOptions('api/v1/selectlist/Employees', '-- Select employee');

    function setFieldValue(name: string, value: string) {
        if (formData) {
            name.split('.').reduce((object, propertyName, index, elements) => {
                if (index === elements.length - 1) {
                    object[propertyName] = value;
                    setFormData(formData);
                }

                if (object && object[propertyName]) {
                    return object[propertyName];
                }
                return null;
            }, formData);
        }
    }

    function submit() {}

    let fields: FieldConfig[] = [
        { name: 'fromEmployeeId', label: 'Replace employee', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        { name: 'toEmployeeId', label: 'With', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
    ];

    const formConfig: FormConfig = {
        fields: fields,
        handleSubmit: submit,
        handleFieldChanged: setFieldValue,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData);


    return (
        <div className='main-content'>
            <Form title={'Employee maintenance'}>
                <Row>
                    <Col md='6'>
                        <SelectListField {...getFieldProps('fromEmployeeId')} options={employees} />
                    </Col>
                    <Col md='6'>
                        <SelectListField {...getFieldProps('toEmployeeId')} options={employees} />
                    </Col>
                </Row>
            </Form>
            <Container fluid>
                <Row>
                    <Col md='12'>
                        <HorizontalTabs
                            id='main-tabs'
                            defaultActiveKey={'tab_Items'}
                            tabs={[
                                {
                                    title: 'Items',
                                    eventKey: 'tab_Items',
                                    component: <EmployeeMaintenance_tab_ItemRevisions fromEmployeeId={formData.fromEmployeeId} toEmployeeId={formData.toEmployeeId} />
                                },
                                {
                                    title: 'Tasks',
                                    eventKey: 'tab_Tasks',
                                    component: <EmployeeMaintenance_tab_WorkflowTasks fromEmployeeId={formData.fromEmployeeId} toEmployeeId={formData.toEmployeeId} />
                                },
                                {
                                    title: 'Projects',
                                    eventKey: 'tab_Projects',
                                    component: <EmployeeMaintenance_tab_Projects fromEmployeeId={formData.fromEmployeeId} toEmployeeId={formData.toEmployeeId} />
                                },
                                {
                                    title: 'Business-partners',
                                    eventKey: 'tab_BusinessPartners',
                                    component: <EmployeeMaintenance_tab_BusinessPartners fromEmployeeId={formData.fromEmployeeId} toEmployeeId={formData.toEmployeeId} />
                                },

                                {
                                    title: 'Brands',
                                    eventKey: 'tab_brands',
                                    component: <EmployeeMaintenance_tab_Brands fromEmployeeId={formData.fromEmployeeId} toEmployeeId={formData.toEmployeeId} />
                                },
                                {
                                    title: 'Categories',
                                    eventKey: 'tab_Categories',
                                    component: <EmployeeMaintenance_tab_ProductCategories fromEmployeeId={formData.fromEmployeeId} toEmployeeId={formData.toEmployeeId} />
                                },
                            ]}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
export default EmployeeMaintenanceView;